import { AHIcon, Box, useTheme } from "arkh";
import React, { ReactNode } from "react";

import Color from "color";

export function TipArea(props: { children: ReactNode }) {
  const color = Color(useTheme().primary).lighten(0.92).toString();
  return (
    <Box
      borderColor="primary"
      cornerRadius="large"
      space="medium"
      style={{
        borderWidth: 2,
        backgroundColor: color,
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      <Box spaceRight="medium" style={{ justifyContent: "center" }}>
        <AHIcon type="help" color="primary" />
      </Box>
      <Box style={{ flex: 1 }}>{props.children}</Box>
    </Box>
  );
}
